/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Edit_ModeInputs */

const en_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Edit Mode`)
};

const fr_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer le mode edition`)
};

const de_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeitungsmodus umschalten`)
};

const it_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva la modalità di modifica`)
};

const ru_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить режим редактирования`)
};

const es_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar el modo de edición`)
};

const zh_cn2_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换编辑模式`)
};

const ja_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集モードを切り替える`)
};

const hi_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादन मोड को चालू/बंद करें`)
};

const pt_pt2_shortcut_keys_name_toggle_edit_mode = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Edit_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar modo de edição`)
};

/**
* | output |
* | --- |
* | "Toggle Edit Mode" |
*
* @param {Shortcut_Keys_Name_Toggle_Edit_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_edit_mode = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Edit_ModeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Edit_ModeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_toggle_edit_mode(inputs)
	if (locale === "de") return de_shortcut_keys_name_toggle_edit_mode(inputs)
	if (locale === "it") return it_shortcut_keys_name_toggle_edit_mode(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_toggle_edit_mode(inputs)
	if (locale === "es") return es_shortcut_keys_name_toggle_edit_mode(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_toggle_edit_mode(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_toggle_edit_mode(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_toggle_edit_mode(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_toggle_edit_mode(inputs)
	return en_shortcut_keys_name_toggle_edit_mode(inputs)
});